// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const BulkRule = lazy(() => import('pages/bulkRule/bulkRule'));

const BulkRuleUpload = (
  <Route path={routeName.bulkRuleUpload}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.RULE_BULK_UPLOAD}>
          <Suspense fallback={<Loading />}>
            <BulkRule />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default BulkRuleUpload;
